<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="DETALHES DO PARCELAMENTOS" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" 
            titleReport="Titulo" :btnHide="true">
                <md-button onclick="history.go(-1);" class="md-button md-site md-just-icon md-round">
                    <i class="fas fa-arrow-left"></i>
                    <md-tooltip md-direction="top">Adicionar Motorista</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID " style="width: 8%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="DATA " style="width: 8%">{{ item.emissao }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="VENDA" style="width: 7%">{{ item.id_pagamento }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CLIENTE" style="width: 27%">{{ item.cliente }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 25%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="PARCELA" style="width: 5%">{{ item.parcela }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="VENCIMENTO" style="width: 10%">{{ item.vencimento }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="VALOR" style="width: 10%">{{ item.valor_parcela }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            cliente: {},
            permissoes: this.$store.state.usuario.permissao,
            columnsPDF: [15, 10, 15, 50, 50, 10, 15, 15],
            headRowsPDF: ['ID', 'DATA', 'VENDA', 'CLIENTE', 'FORNECEDOR', 'PARCELA', 'VENCIMENTO', 'VALOR'],
            bodyRowsPDF: ['id', 'emissao', 'id_pagamento', 'cliente', 'fornecedor', 'parcela', 'vencimento', 'valor_parcela'],
            fildsTXT: ['id', 'emissao', 'id_pagamento', 'cliente', 'fornecedor', 'parcela', 'vencimento', 'valor_parcela'],
            columnsExcel: [
                
                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "DATA",
                    field: "emissao",
                },
                {
                    label: "VENDA",
                    field: "id_pagamento",
                },
                {
                    label: "CLIENTE",
                    field: "cliente",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "PARCELA",
                    field: "parcela"
                },
                {
                    label: "VENCIMENTO",
                    field: "vencimento",
                },
                {
                    label: "VALOR",
                    field: "valor_parcela",
                }
            ],
            search: null,
            tableData: [],
            searchedData: []
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'parcelamentos/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.dados = response.data.dados;
                        this.tableData = response.data.dados;
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf, item.empresa]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'motoristasUpdate',
                params: {
                    id: id
                }
            })
        }
    },

};
</script>

<style>
.text-label {
    margin-top: -25px !important;
}

.md-toggle-password,
.error {
    visibility: hidden !important;
}
</style>
